var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "column": "",
      "align-start": ""
    }
  }, [!!_vm.text ? _c('span', [_vm._v(" " + _vm._s(_vm.text) + " ")]) : _vm._e(), !!_vm.desc ? _c('span', [_vm._v(" " + _vm._s(_vm.desc) + " ")]) : _vm._e(), !!_vm.coda ? _c('span', [_vm._v(" " + _vm._s(_vm.coda) + " ")]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }